module.exports = __webpack_public_path__ + "static/media/em-38.42567f94.png";